import React from 'react';

import PropertyController from '../../controller/PropertyController';
import Const from '../../util/Constants';

import FieldText from '../common/FieldText';
import FieldTextArea from '../common/FieldTextArea';
import FieldDate from '../common/FieldDate';
import FieldDateTime from '../common/FieldDateTime';
import FieldSelect from '../common/FieldSelect';
import FieldMultiSelect from '../common/FieldMultiSelect';
import FieldToggle from '../common/FieldToggle';
import FieldAddress from '../common/FieldAddress';
import FieldNumber from '../common/FieldNumber';
import FieldDecimal from '../common/FieldDecimal';

import './LeadAddEdit.css';
import FieldFile from '../common/FieldFile';

class PropertyAddEditCustom extends React.Component {

  getCustomFields = (property, fields, onValueChange, inValid) => {
    const customField = PropertyController.getCustomFields(fields);
    let list = [];
    const keys = Object.keys(customField);
    for (let i = 0; i < keys.length; i++) {
      const type = customField[keys[i]].field_type;
      const key = keys[i];
      const field = customField[keys[i]];
      const value = property[keys[i]];
      const innerData = {
        key: key, id: key, field: field, value: value,
        onValueChange: onValueChange, inValid: inValid, document_type: this.props.documentType
      };
      if (type === Const.Text) list.push(<FieldText {...innerData} />);
      if (type === Const.TextArea) list.push(<FieldTextArea {...innerData} />);
      else if (type.includes(Const.MultiSelect)) list.push(<FieldMultiSelect {...innerData} />);
      else if (type.includes(Const.Select)) list.push(<FieldSelect {...innerData} />);
      else if (type === Const.Date) list.push(<FieldDate {...innerData} />);
      else if (type === Const.DateTime) list.push(<FieldDateTime {...innerData} />);
      else if (type === Const.Toggle) list.push(<FieldToggle {...innerData} />);
      else if (type === Const.Address) list.push(<FieldAddress {...innerData} />);
      else if (type === Const.Number) list.push(<FieldNumber {...innerData} />);
      else if (type === Const.Decimal) list.push(<FieldDecimal {...innerData} />);
      else if (type === Const.Files) list.push(<FieldFile {...innerData} />);
    }
    return list;
  };

  render() {
    const property = this.props.property;
    const fields = this.props.model.fields;
    const onValueChange = this.props.onValueChange;
    const inValid = this.props.inValid;

    const list = this.getCustomFields(property, fields, onValueChange, inValid);
    if (list.length === 0) return null;
    return <><div className="formhead col-md-12"><h2>Additional Information</h2></div>{list}</>;
  }
}

export default PropertyAddEditCustom;